import { Component, Input } from '@angular/core'
import { VetcorPricingRowService } from '../vetcor-pricing-row.service'

@Component({
   selector: 'vc-validation-warning-modal',
   standalone: false,
   templateUrl: './validation-warning-modal.component.html',
   styleUrl: './validation-warning-modal.component.scss',
})
export class ValidationWarningModalComponent {
   constructor(private pricingService: VetcorPricingRowService) {}

   showValidationModal = this.pricingService.showValidationModal()
   validationMessage = this.pricingService.validationMessage()
}
